import { DialogContent, Modal, Paper } from '@material-ui/core'
import React, { FC, ReactElement } from 'react'
import { useReportPortalContainer } from '../../Hooks/useReportPortalContainer'
import MODAL_DEFAULT_WIDTH from './Constants'
import Icon, { IconName } from '../Icon'

type Props = {
    classNames?: string
    children: ReactElement | ReactElement[]
    isOpen: boolean
    onClose?: () => void
    isClosableWithXButton?: boolean
    maxWidth?: string
}
/**
 * Layered Modal allows for the stacking of modals on top of each other.
 *
 * @param classNames - Class name to pass through to the modal.
 * @param children - The content of the Modal.
 * @param isOpen - Is the modal currently displayed?
 * @param onClose - Function to run on close.
 * @param isClosableWithXButton - This is closable using the close button in the corner?
 * @param maxWidth - The maximum width for this modal.
 */
export const LayeredModal: FC<Props> = ({
    classNames,
    children,
    isOpen,
    onClose,
    isClosableWithXButton,
    maxWidth
}: Props): ReactElement => (
    <Modal
        className={`modal ${classNames} layered-modal`}
        open={isOpen}
        onClose={onClose}
        container={useReportPortalContainer()}
    >
        <Paper className='lm-paper' style={{ maxWidth: maxWidth ?? MODAL_DEFAULT_WIDTH }}>
            <DialogContent>
                {isClosableWithXButton && (
                    <div className='modal-header'>
                        {isClosableWithXButton && (
                            <div className='button-x' onClick={onClose}>
                                <Icon iconName={IconName.X} />
                            </div>
                        )}
                    </div>
                )}
                <div
                    className={`layered-modal-content-wrapper modal-content-wrapper${
                        isClosableWithXButton ? '-closable' : ''
                    }`}
                >
                    {children}
                </div>
            </DialogContent>
        </Paper>
    </Modal>
)
